import React, { useState, useEffect } from "react";
import { Base_Url } from ".././Services/ApiFile";
import { NavLink, useNavigate } from "react-router-dom";
import { Button, CircularProgress, Typography, IconButton, Modal, TextField } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useGlobalContext } from "../../provider/context/userContext";
import posthog from "posthog-js";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import jwt_decode from "jwt-decode";
import competitive_intellligent from "../../images/competitiveIntelligence 1.svg";
import CloseIcon from '@mui/icons-material/Close';
import { Alert, Snackbar } from '@mui/material';

const theme = createTheme();
const brands = ['3 gnar', 'adj - american dj', 'algreen products', 'all seasons',
  'american fuel tank', 'american telecast products', 'apache', 'aqua lily pad',
  'aterian group', 'auto floor guard', 'baby trend', 'bac industries', 'banzai',
  'barbour international', 'bear mountain bbq', 'best ride on cars',
  'bestier - marketplace fulfillment', 'bestway', 'bestway network technology',
  'boost oxygen', 'boss audio systems', 'brock supply', 'brower', 'brut worm farms',
  'bumbo distribution usa', 'c&s holmes', 'cabana filters', 'camco manufacturing',
  'caravan global', 'champion packaging and distribution', 'chapin manufacturing',
  'chargepoint', 'chauvet', 'cinderella - hayward whole goods', 'cinderella - main access',
  'cinderella - trevi', 'cinderella - unicel', 'cinderella - vinyl works', 'clam corp',
  'cookinpellets', 'curtis international', 'decoro home', 'delta electronics', 'deltess corp',
  'design ideas', 'devoko - marketplace fulfillment', 'dewitt company', 'disc-o-bed',
  'duraflame', 'dura-trel', 'duravent', 'dynamic motion dba larktale', 'dynasty mattress',
  'entrepreneur venture capital', 'ewc', 'f2c global limited - marketplace fulfillment',
  'farm innovators', 'fastpak systems', 'fcmp outdoor', 'findlay machine & tool',
  'fisher-price brands', 'fogatti', 'gaia enterprises', 'general marketing solutions',
  'genesis archery', 'get busy playin', 'gibson overseas', 'glass kings distribution',
  'goba sports', 'golden designs', 'goldwood', 'good ideas', 'gracious living corp',
  'graham-field', 'green touch industries', 'grimco', 'gsm', 'gulf coast sand',
  'haden appliances', 'hailo us', 'hauck usa', 'hc companies', 'hedstrom fitness',
  'highland trading', 'hit run steal', 'hms mfg', 'hodedah import', 'holahatha',
  'holyn enterprises', 'hurricane fans', 'hurricane ventures', 'hydrofarm', 'i2poly',
  'impex', 'ina international', 'innovative enterprise', 'international leisure products - swimline',
  'intex', 'iris usa', 'jaxpety corp', 'jewett cameron', 'jiangsu jilong sport and leisure',
  'john boos & co', 'jonas corporation', 'juggernaut storage', 'jumpflex usa', 'jumpsport',
  'kathys universe limited', 'keter us', 'keter us - marketplace fulfillment', 'kids2 kids',
  'kms - marketplace fulfillment', 'kti hydraulics', 'la la land', 'lafuma america', 'lasko products',
  'lifetime products', 'ltl wholesale', 'mac sports', 'maroi wicker sl', 'mattel', 'maven lane',
  'maxxsonics', 'mc appliance', 'meco corporation', 'medal sports', 'medion ag', 'michigan peat',
  'miller manufacturing', 'mitek - mtx', 'morrell manufacturing', 'motion water sports', 'motis',
  'mrcool', 'mscki', 'multy home lp', 'muse home', 'national presto industries',
  'neosheng commerce', 'newell brands distribution', 'newell brands distribution - rubbermaid',
  'ningbo suntime garden furniture', 'north atlantic imports', 'novion',
  'obsidian industries', 'odyssey innovative designs', 'oneida air systems', 'oriental recreational products',
  'origami group', 'packaging corporation', 'palmetto vermiculite', 'panacea products', 'paricon',
  'pinnacle climate technologies', 'pj chonburi parawood', 'plantonix', 'polygroup evergreen limited',
  'polygroup trading limited', 'prism fitness', 'productworks', 'q power', 'qiduo innovation',
  'radio flyer', 'ram quality products', 'razor', 'really useful box', 'recpro', 'reeves international',
  'rev a shelf', 'revoace griddle', 'rhythm healthcare', 'rich dad', 'rj thomas mfg',
  'robert bosch tool corporation', 'royalbaby cycle beijing', 'rugged ranch products', 'saftron',
  'samsonite', 'scepter manufacturing', 'sengoku la', 'shanghai sishun e-commerce', 'shark ninja',
  'shelf reliance', 'shelterlogic', 'sienhua group', 'skb cases', 'sleepgram', 'sohnen enterprises',
  'solar sun rings', 'sound around', 'spin master', 'spyra gmbh', 'stamina products', 'sterilite',
  'suncast', 'supply chain sources lifesmart', 'swim ways - kelsyus - import', 'swimline corp',
  'tastemakers', 'taylor technologies', 'the ames company att southern', 'the ames company closetmaid',
  'tipke manufacturing', 'titan post drivers', 'toughbuilt industries', 'trc recreation',
  'tri global enterprises', 'tricam industries', 'true play', 'ultimate sack', 'ultra soap international',
  'union grand imp & exp', 'united solutions', 'united states stove company', 'uriah products', 'us silica company',
  'veritiv', 'vevor - marketplace fulfillment', 'vuly usa operations corp', 'w.c. redmon', 'wall control', 'watkins wellness',
  'wood products international', 'xdp recreation', 'yakima products', 'yiwu guoyou', 'yj usa', 'zorin int sp zoo',
  'hkc-us', 'living essentials', 'the scotts company', 'all things cedar', 'gns sales', 'shaw international trading','coaster company',
  'test account','truride tech', 'pvp industries','hurav','homecare products','propeller brands','kitchen elite','kimpex a/s',
  'dolu oyuncak san ve tic','heynemo','cozayh','omega paw','vivere']

const Login = () => {
  const globalContext = useGlobalContext();
  const [visiblePassword, setVisiblePassword] = useState(false);
  const [openResetModal, setOpenResetModal] = useState(false);
  const [resetLoader, setResetLoader] = useState(false);
  const navigate = useNavigate();
  const [values, setValues] = useState({
    username: "",
    password: ""
  });
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [resetRequired, setResetRequired] = useState(false);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const isMobile = window.innerWidth <= 768; // or use 600 based on your design
    if (isMobile) {
      setShowBanner(true);
    }
  }, []);

  const handleSnackClose = () => {
    setShowBanner(false);
  };
  const handleEmailSubmit = async (e) => {
    setResetLoader(true)
    e.preventDefault();
    try {
      const response = await fetch(Base_Url + '/auth/password-reset/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: email
        }),
      });

      const data = await response.json();

      if (response.ok) {
        if (data.status === "error") {
          setMessage('Password reset link has been sent to your email');
          globalContext.Alert("error", data.message);
        } else {
          setMessage('Password reset link has been sent to your email');
          globalContext.Alert("success", "Password reset link has been sent to your email");
        }
        setResetLoader(false)
        setOpenResetModal(false);

      } else {
        setMessage(data.detail || 'Failed to send reset link');
        globalContext.Alert("error", data.detail || 'Failed to send reset link');
      }
    } catch (error) {
      setMessage('An error occurred. Please try again.');
      globalContext.Alert("error", 'An error occurred. Please try again.');
    }
  };

  // Handle change function handle all the change that we make in form
  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleNavigate = () => {
    if (brands.includes(values.username.toLowerCase())) {
      console.log("innn")
      navigate("/dashboard/wbr-page");
    } else {
      console.log("offff")
      navigate("/dashboard/brand-analysis");
    }
  }
  // handle submit use for verify the user
  const handleSubmit = async event => {
    event.preventDefault();
    if (!values?.password || !values?.username)
      return globalContext.Alert(
        "error",
        "Please enter your password and username"
      );
    const requestOptions = {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify({
        username: values.username,
        password: values.password
      })
    };

    fetch(Base_Url + "/auth/login/", requestOptions)
      .then(response => {
        return response.json();
      })
      .then(async data => {
        if (data.username) {
          const token = data.token;
          const username = data.username;
          if (
            globalContext.localHostNotPresent() &&
            globalContext.checkDevMode() &&
            globalContext.devSiteNotPresent()
          ) {
            posthog.reset();
            posthog.identify(data.username);
          }
          if (
            globalContext.localHostNotPresent() &&
            globalContext.checkDevMode() &&
            globalContext.devSiteNotPresent() &&
            globalContext?.userData?.username
          ) {
            posthog.capture(
              `${globalContext.userData.username + " - User login"}`,
              {
                user: globalContext.userData.username
              }
            );
          }
          let response = await fetch(Base_Url + "/auth/token/", requestOptions);
          if (response.status === 200) {
            let data = await response.json();
            data["token"] = token;
            data["username"] = username;
            globalContext.setAuthToken(data);
            globalContext.setLoginData(jwt_decode(data.access));
            globalContext.setUserData(data);
            globalContext.Alert("success", "Welcome " + data?.username);
            localStorage.setItem("authToken", JSON.stringify(data));
            handleNavigate()
          } else {
            throw new Error("Failed to save login details");
          }
        } else {
          throw new Error(data.message);
        }
      })
      .catch(error => {
        globalContext.Alert("error", error.message);
      });
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          height: "calc(80vh - 65px)",
          overflow: "hidden",
          maxWidth: "1000px",
          marginX: "auto",
          marginTop: "100px",
          alignItems: "center",
          padding: "50px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)"
        }}
      >
        <Grid container component='main' spacing={3}>
          <CssBaseline />
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "10px"
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px"
              }}
            >
              <span
                style={{
                  color: "#000000",
                  fontSize: "24px",
                  fontWeight: "bold",
                  lineHeight: "20px",
                  fontFamily: "satoshi"
                }}
              >
                Welcome back!
              </span>
              <span
                style={{
                  color: "#000000",
                  fontSize: "13px",
                  fontFamily: "satoshi"
                }}
              >
                Sign in to know what your customers are saying about your
                products!
              </span>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "100%"
              }}
            >
              <label
                htmlFor='username'
                style={{
                  color: "#000000",
                  fontSize: "16px",
                  fontWeight: "bold",
                  fontFamily: "satoshi !important"
                }}
              >
                Username
              </label>
              <input
                type='text'
                name='username'
                value={values?.username}
                onChange={handleChange}
                id=''
                placeholder='Enter your name'
                style={{
                  backgroundColor: "#F2F2F2",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  width: "100%",
                  color: "#000000",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  fontFamily: "satoshi !important"
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "100%"
              }}
            >
              <label
                style={{
                  color: "#000000",
                  fontSize: "16px",
                  fontWeight: "bold",
                  fontFamily: "satoshi !important"
                }}
                htmlFor='password'
              >
                Password
              </label>
              <div
                style={{
                  backgroundColor: "#F2F2F2",
                  padding: "8px 20px",
                  borderRadius: "5px",
                  width: "100%",
                  color: "#000000",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  fontFamily: "satoshi !important"
                }}
              >
                <input
                  type={visiblePassword ? "text" : "password"}
                  onChange={handleChange}
                  name='password'
                  placeholder='Enter your password'
                  style={{
                    border: "none",
                    backgroundColor: "transparent",
                    outline: "none",
                    fontSize: "14px",
                    fontFamily: "satoshi !important"
                  }}
                />
                {visiblePassword ? (
                  <VisibilityOffIcon
                    style={{ color: "#52525B" }}
                    onClick={() => setVisiblePassword(!visiblePassword)}
                  />
                ) : (
                  <RemoveRedEyeIcon
                    style={{ color: "#52525B" }}
                    onClick={() => setVisiblePassword(!visiblePassword)}
                  />
                )}
              </div>
            </Box>

            <Button
              variant=''
              sx={{
                width: "100%",
                background: "#000000",
                color: "white",
                padding: "10px",
                fontSize: "14px",
                fontFamily: "satoshi !important",
                "&:hover": {
                  background: "#000000",
                  color: "#ffffff"
                }
              }}
              onClick={handleSubmit}
            >
              Sign in
            </Button>
            <p style={{
              color: "#000000",
              textAlign: "center",
              width: "100%",
              fontSize: "1rem",
              fontFamily: "satoshi !important",
              borderBottom: "1px solid #C6CAD2",
              marginBottom: "0px",
              marginTop: "0px",
              paddingBottom: "10px",
            }}>
              <span
                style={{
                  fontWeight: "bold",
                  cursor: "pointer"
                }}
                onClick={() => setOpenResetModal(true)}
              >
                Reset Password
              </span>
            </p>
            <p
              style={{
                color: "#000000",
                textAlign: "center",
                width: "100%",
                fontSize: "1rem",
                fontFamily: "satoshi !important"
              }}
            >
              <span>
                Don't have an account?{" "}
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    marginLeft: "5px",
                    cursor: "pointer"
                  }}
                  onClick={() => navigate("/auth/register")}
                >
                  Create Account
                </span>
              </span>
            </p>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <img
              src={competitive_intellligent}
              alt=''
              style={{
                objectFit: "contain",
                width: "100%"
              }}
            />
          </Grid>
        </Grid>

        {/* Reset Password Modal */}
        <Modal
          open={openResetModal}
          onClose={() => setOpenResetModal(false)}
          aria-labelledby="reset-password-modal"
          aria-describedby="reset-password-form"
        >
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: '8px',
            outline: 'none'
          }}>
            <Box sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 2
            }}>
              <h2 id="reset-password-modal" style={{
                margin: 0,
                fontFamily: 'satoshi',
                fontSize: '20px',
                fontWeight: 'bold'
              }}>
                Reset Password
              </h2>
              <CloseIcon
                onClick={() => setOpenResetModal(false)}
                sx={{
                  cursor: 'pointer',
                  color: '#52525B'
                }}
              />
            </Box>
            <p style={{
              marginBottom: '20px',
              fontFamily: 'satoshi',
              fontSize: '14px',
              color: '#52525B'
            }}>
              Enter your Username and we'll send a password reset link to your merchant partner's email address.
            </p>
            <form onSubmit={handleEmailSubmit}>
              <TextField
                fullWidth
                label="Username"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                sx={{
                  mb: 3,
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: '#E5E7EB',
                    },
                    '&:hover fieldset': {
                      borderColor: '#000000',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#000000',
                    },
                  },
                  '& .MuiInputLabel-root': {
                    fontFamily: 'satoshi',
                    '&.Mui-focused': {
                      color: '#000000',
                    },
                  }
                }}
              />
              {resetLoader ?
                <CircularProgress sx={{
                  marginLeft: "40%"
                }}></CircularProgress> :
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{
                    backgroundColor: '#000000',
                    color: '#ffffff',
                    padding: '10px',
                    fontSize: '14px',
                    fontFamily: 'satoshi',
                    textTransform: 'none',
                    '&:hover': {
                      backgroundColor: '#000000',
                    }
                  }}
                >
                  Send Reset Link
                </Button>
              }

            </form>
          </Box>
        </Modal>
        <Snackbar open={showBanner} onClose={handleSnackClose}>
          <Alert
            severity="info"
            sx={{ width: '100%' }}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={handleSnackClose}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            }
          >
            Hi there,<br />
            We are working on the mobile-friendly version of this. Please consider using your desktop or tablet in the meanwhile.
          </Alert>
        </Snackbar>
      </Box>
    </ThemeProvider>
  );
};

export default Login;